module.exports = __webpack_public_path__ + "media/src/images/landing/raspi-icon-fc678d77dc5e977cf047074484d291bc.png";